module.exports = __webpack_public_path__ + "img/deep-dive-report.6b0c8852.png";